var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.element,{tag:"component",class:("\n    app-icon\n    iconfont\n    icon-" + _vm.type + "\n    state-" + (_vm.targetType.state) + "-icon\n  "),attrs:{"title":_vm.targetType.title},on:{"click":_vm.iconClick}})}
var staticRenderFns = []

export { render, staticRenderFns }